import {createAction} from 'typesafe-actions';

export const urlServiceUpdateSettingsInUrl = createAction(
    'URL_SERVICE_UPDATE_SETTINGS_IN_URL',
    (action) => () => action({}),
);
